import { initDesktopHeader } from './desktop';
import { initMobileHeader } from './mobile';

import 'wicg-inert';


export function initSiteHeader() {
    initDesktopHeader();
    initMobileHeader();
    initSearch();

    function initSearch() {
        const header        = document.querySelector('#siteHeader'),
              searchToggler = header.querySelector('.-searchToggler'),
              searcher      = header.querySelector('.siteHeader-searcher'),
              input         = searcher.querySelector('input'),
              link          = searcher.querySelector('a');

        searcher.inert = true;

        input.addEventListener('keyup', () => {
            link.href = input.value ? `/?s=${encodeURIComponent(input.value)}` : '';
        });
        input.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' && input.value) {
                link.click();
            } else if (event.key === 'Escape') {
                hide();
            }
        });
        document.addEventListener('click', event => {
            if (event.target !== searchToggler && event.target !== searcher && !searcher.contains(event.target)) {
                hide();
            }
        });
        searchToggler.addEventListener('click', toggle);
        
        function show() {
            searchToggler.classList.add("is--active");
            searcher.classList.add("is--active");
            searcher.inert = false;
            setTimeout(() => {
                input.focus();
            }, 0);
        }

        function hide() {
            input.value = '';
            input.blur();
            searchToggler.classList.remove('is--active');
            searcher.classList.remove('is--active');
            searcher.inert = true;
        }

        function toggle() {
            searcher.classList.contains('is--active') ? hide() : show();
        }
    }


}

